//  @flow
import {
    ONBOARDING_ADD_ITEM,
    ONBOARDING_REMOVE_ITEM,
    ONBOARDING_SET_ACTIVE
} from "../constants/onboarding";

export type OnboardingAction =
  | AddItem
  | RemoveItem

type AddItem = { type: typeof ONBOARDING_ADD_ITEM, song: any, id: any };
type RemoveItem = { type: typeof ONBOARDING_REMOVE_ITEM, value: any };


export function addItem(id: any): AddItem {
  return { type: ONBOARDING_ADD_ITEM, id: id };
}

export function removeItem(id: any): RemoveItem {
  return { type: ONBOARDING_REMOVE_ITEM, id: id };
}

export function setActive(active: boolean): RemoveItem {
  return { type: ONBOARDING_SET_ACTIVE, active: active };
}

export const onboardingActionCreators = {
  addItem,
  removeItem,
  setActive,
};
